module.exports = __webpack_public_path__ + "static/img/MockOnboardingCollectiveSample.be4c17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MockOnboardingCollectiveSample.png
// module id = pru8
// module chunks = 1